import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { ProjectWeb } from 'app/shared/model/project.model';
import { TeamWeb } from 'app/shared/model/team.model';

import { SelectedFoldersMap } from './folder-selection.service.types';

@Injectable({
  providedIn: 'root',
})
export class FolderSelectionService {
  private readonly selectedFoldersSubject = new BehaviorSubject<SelectedFoldersMap>(new Map());

  public readonly selectedFolders$ = this.selectedFoldersSubject.asObservable();

  public get selectedFolders() {
    return this.selectedFoldersSubject.value;
  }

  public get selectedFoldersIds() {
    return [...this.selectedFoldersSubject.value.keys()];
  }

  public toggleFolderSelection(folder: ProjectWeb | TeamWeb) {
    const { selectedFolders } = this;
    if (selectedFolders.has(folder._id)) {
      selectedFolders.delete(folder._id);
    } else {
      selectedFolders.set(folder._id, folder);
    }
    this.selectedFoldersSubject.next(selectedFolders);
  }

  public deselectAllFolders() {
    const { selectedFolders } = this;
    selectedFolders.clear();
    this.selectedFoldersSubject.next(selectedFolders);
  }

  public selectFolder(folder: ProjectWeb | TeamWeb) {
    const { selectedFolders } = this;
    selectedFolders.set(folder._id, folder);
    this.selectedFoldersSubject.next(selectedFolders);
  }

  public selectFolders(folders: (ProjectWeb | TeamWeb)[]) {
    const { selectedFolders } = this;
    folders.forEach((folder) => selectedFolders.set(folder._id, folder));
    this.selectedFoldersSubject.next(selectedFolders);
  }

  public deselectFolder(id: string) {
    const { selectedFolders } = this;
    if (selectedFolders.has(id)) {
      selectedFolders.delete(id);
    }
    this.selectedFoldersSubject.next(selectedFolders);
  }
}
